import { render, staticRenderFns } from "./LiabilitiesDefault.vue?vue&type=template&id=7f29e5f0&"
import script from "./LiabilitiesDefault.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports